import {makeAutoObservable} from "mobx";
import {DIMENSIONS, LINN128} from "../model";

export const ROWS = 8;
export const COLS = 16;

// export type GridXY = [number, number];

export type Cell = {
    x: number,          // start at 0   [0, 0] is bottom left
    y: number,          // start at 0
    color: number,
    value: number|null|string
}

export type Grid = Cell[][];

class GridStore {

    model: number;
    columns: number;
    rows: number;
    cells: Grid;

    constructor(columns: number, rows: number) {

        makeAutoObservable(this);

        this.model = LINN128;

        this.columns = DIMENSIONS[this.model].cols;
        this.rows = DIMENSIONS[this.model].rows;
        this.cells = new Array<Array<Cell>>(this.columns);
        for (let x = 0; x < this.columns; x++) {
            const col: Cell[] = new Array<Cell>(this.rows);
            for (let y = 0; y < this.rows; y++) {
                col[y] = {
                    x: x,
                    y: y,
                    color: 0,
                    value: 0
                };
            }
            this.cells[x] = col;
        }

    }

    redim(model: number) {
        // const c = DIMENSIONS[model].cols;
        // const r = DIMENSIONS[model].rows;
        // if (c < this.columns) {
        // }
        this.columns = DIMENSIONS[model].cols;
        this.rows = DIMENSIONS[model].rows;
        this.cells = new Array<Array<Cell>>(this.columns);
        for (let x = 0; x < this.columns; x++) {
            const col: Cell[] = new Array<Cell>(this.rows);
            for (let y = 0; y < this.rows; y++) {
                col[y] = {
                    x: x,
                    y: y,
                    color: 0,
                    value: 0
                };
            }
            this.cells[x] = col;
        }
    }

    setModel(model: number) {
        if (model !== this.model) {
            this.redim(model);
        }
        this.model = model;
    }

}

export const grid = new GridStore(COLS, ROWS);
